import React,{ useRef, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import {useSelector, useDispatch} from 'react-redux'
import PropTypes from 'prop-types'
import {updateConfig} from '../../../app/action'
import { getDataFromURL } from '../../../utilities/function/urlparams'

let Breadcrumbs = (props) => {
  const { data, step, cid, location } = props
  const initFlag = useRef(false)

  const visitedArray = useRef([])
  const prevStep = useRef(undefined)
  const isNewSession = useRef(undefined)

  useEffect(()=>{
    if (prevStep.current !== step){
      visitedArray.current.push(step)
      prevStep.current = step
    }
  },[prevStep,step])



  const {configurations,cartStatus} = useSelector(state=>({
    configurations: state.app.configurations,
    cartStatus: state.app.cartStatus
  }))
  const { a } = getDataFromURL(location.search)
  const dispatch = useDispatch()
  useEffect(()=>{
    const updateBreadCrumbs = () => {
      if(data && data.length>0){
        updateConfig(configurations,cid,{breadcrumbs:data},dispatch)
        initFlag.current = true
      }
    }
    if(!initFlag.current && (cartStatus==="success" || cartStatus==="error")){
      if(configurations[cid] && configurations[cid].selectedProduct){
        if(configurations[cid].uuid){
          updateBreadCrumbs()
        }else{
          if(parseInt(cid)=== configurations[cid].selectedProduct.id){
            updateBreadCrumbs()
          }
        }
      }
      if(step > 0){
        isNewSession.current = false
      }else{
        isNewSession.current = true
      }
    }
  },[configurations, initFlag, dispatch,cid,data,step,cartStatus])

  const renderList = () => {
    if (data && data.length > 0) {
      return data.map((item, index) => {
        const { label, itemStep,configKey } = item
        const isLast = () => {
          return index === data.length - 1
        }
        const isSelected = () => {
          return itemStep === step
        }
        const hasConfigKey = () =>{
          if(configurations[cid] && configurations[cid][configKey]){
            if(Array.isArray(configurations[cid][configKey] )){
              if(configurations[cid][configKey].length>0){
                return true
              }
              return false
            }
            return true
          }
          return  false
        }
        const prevHasConfigKey = () =>{
          const iterationStep = item.itemStep
          let flag = true
          const filtredData = data.filter(i=>i.itemStep < iterationStep )
          //const filtredData = data
          if(filtredData && filtredData.length > 0){
            filtredData.forEach(i=>{
              if(configurations[cid] && !configurations[cid][i.configKey]){
                flag = false
              }
              if(configurations[cid] && configurations[cid][i.configKey] && Array.isArray(configurations[cid][i.configKey]) && configurations[cid][i.configKey].length<1){
                flag = false
              }
            })
          }
          return flag
        }
        const isVisited = () =>{
          if(visitedArray && visitedArray.current && Array.isArray(visitedArray.current) && visitedArray.current.length > 0){
            if(visitedArray.current.find(i=>i===itemStep)){
              return true
            }
          }
          if(!isNewSession.current){
            return true
          }
          return false
        }
        const isActive  = () =>{
          if(item && item.itemStep===0 && hasConfigKey()){
            return true
          }else{
            if(prevHasConfigKey() && isVisited()){



              return true
            }
          }
          return false
        }
        const clickableItem = () => {
          const onClick = () =>{
            updateConfig(configurations,cid,{step:itemStep},dispatch)
          }
          return (
            <li onClick={onClick} className='of-bread-crumbs__item of-bread-crumbs__item--clickable clearfix' key={index}>
              <div className={`${isSelected() ? 'text-font-1-100' : 'text-font-2-100'} of-bread-crumbs__item-text`}>{label}</div>
              {!isLast() ? <div className='of-bread-crumbs__item-arrow'><i className='icon-of-arrow text-font-4-100' /></div> : ''}
            </li>
          )
        }
        if(a==='edit'){
          return (clickableItem())
        }else{
          if(isActive()){
            return (clickableItem())
          }
          return (
            <li className='of-bread-crumbs__item clearfix' key={index}>
              <div className={`${isSelected() ? 'text-font-1-100' : 'text-font-5-100'} of-bread-crumbs__item-text`}>{label}</div>
              {!isLast() ? <div className='of-bread-crumbs__item-arrow'><i className='icon-of-arrow text-font-4-100' /></div> : ''}
            </li>
          )
        }

      })
    }
  }
  return (
    <div className='of-bread-crumbs'>
      <ul className='of-bread-crumbs__list clearfix'>
        {renderList()}
      </ul>
    </div>
  )
}

Breadcrumbs.propTypes = {
  data: PropTypes.any,
  step: PropTypes.number,
  location: PropTypes.any,
  cid: PropTypes.any
}

Breadcrumbs = withRouter(Breadcrumbs)

export default Breadcrumbs
